import React, { useContext } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { Spinner } from 'formlabs-web-components/Navigation';

import ProductList from './ProductList';

import CountryContext from '../../context/country';
import useFetchProducts from '../../hooks/useFetchProducts';
import clientOnly from '../../hoc/clientOnly';

const UpsellProducts = ({ children, skus, storeId }) => {
  const { loading, data } = useFetchProducts(storeId, skus.join(','), true);
  const context = useContext(CountryContext);

  if (loading) {
    return <Spinner size={6} />;
  }

  if (!data || !data.length) {
    return null;
  }

  return (
    <div>
      {children}
      <ProductList
        hideHeader
        highlightBundles={false}
        baseUrl={context.storePage}
        products={data}
      />
    </div>
  );
};

export default compose(
  connect(state => {
    return {
      storeId: state.store.id
    };
  }),
  clientOnly
)(UpsellProducts);
